import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AssetsService } from '../assets.service';
import { map, startWith } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { error, event } from 'jquery';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastmessageService } from 'src/app/toastmessage.service';

@Component({
  selector: 'app-asset-details-dialog',
  templateUrl: './asset-details-dialog.component.html',
  styleUrls: ['./asset-details-dialog.component.scss']
})
export class AssetDetailsDialogComponent implements OnInit {

  // assetEntry!: FormGroup;
  searchorg: string = '';
  poNo: any = '';
  blockName: any = '';
  roomNo: any = '';
  noAssets: any = '';
  orafusionbuildind: any;
  buildingName: any;
  majordetails: any;
  catMajorId: any;
  minorlist: any;
  catMinorId: any;
  orgType: any;
  orcFusionBuildingCode: any;
  organizationlist: any;
  blocklist: any;
  blockNo: any;
  floorNo: any;
  roomType: any;
  orgId: any;
  buildingId: any;
  saveDetails: any;
  floordetails: any;
  Roomdetails: any;
  blockNodetails: any;
  @ViewChild('myInput') inputElement!: ElementRef;
  @ViewChild('blockname') blocknameElement!: ElementRef;
  @ViewChild('roominput') roomElement!: ElementRef;
  @ViewChild('noAsset') noAssetElement!: ElementRef;
  ngOnInit(): void {
    // this.assetEntry = this.fb.group({
    //   poNo: ['', Validators.required],
    //   blockName: ['', Validators.required],
    //   roomNo: ['', Validators.required],
    //   noAssets: ['', Validators.required],
    // });

    this.blockCategory();
  }

  constructor(public dialogRef: MatDialogRef<AssetDetailsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, private assetsservice: AssetsService, private spinner: NgxSpinnerService, private toast: ToastmessageService) { }

  onNoClick() {
    this.dialogRef.close();
  }

  search(searchorg: any) {
    console.log('searchorg', searchorg);
    this.spinner.show();
    this.assetsservice.orafusion(searchorg).subscribe(
      {
        next: (res: any) => {
          this.orafusionbuildind = res;
          console.log('orafusionbuildind', this.orafusionbuildind);
          this.buildingName = this.orafusionbuildind[0].buildingName;
          this.buildingId = this.orafusionbuildind[0].buildingId;
          this.orcFusionBuildingCode = this.orafusionbuildind[0].orcFusionBuildingCode;
          this.spinner.hide();
          this.majorcategory();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    );
  }

  majorcategory() {
    this.spinner.show();
    this.assetsservice.getmajor().subscribe(
      {
        next: (res: any) => {
          this.majordetails = res;
          console.log('majordetails', this.majordetails);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    );
  }

  onSelectedMajor(event: any) {
    this.catMajorId = event.target.value;
    console.log('catMajorId', this.catMajorId);
    this.spinner.show();
    this.assetsservice.getminor(this.catMajorId).subscribe(
      {
        next: (res: any) => {
          this.minorlist = res;
          console.log('minorlist', this.minorlist);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    );
  }

  onSelectedMinor(event: any) {
    const selectedCatMinorId = event.target.value;
    const selectedData = this.minorlist.find((data: any) => data.catMinorId === Number(selectedCatMinorId));
    if (selectedData) {
      this.catMinorId = selectedData.catMinorId;
      this.orgType = selectedData.orgType;
    }
    this.spinner.show();
    this.assetsservice.getorganization(this.orcFusionBuildingCode, this.orgType).subscribe(
      {
        next: (res: any) => {
          this.organizationlist = res;
          console.log('organizationlist', this.organizationlist);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    );
  }

  onSelectedOrganization(event: any) {
    this.orgId = event.target.value;
  }

  blockCategory() {
    this.spinner.show();
    this.assetsservice.getblock().subscribe(
      {
        next: (res: any) => {
          this.blocklist = res;
          this.blockNo = this.blocklist.blockNo;
          this.floorNo = this.blocklist.floorNo;
          this.roomType = this.blocklist.roomType;
          console.log('blocklist', this.blocklist);
          this.spinner.hide();
        },
        error: (error: any) => {
          this.spinner.hide();
        }
      }
    )
  }
  onSelectedBlock(event: any) {
    this.blockNodetails = event.target.value;
    console.log('blockNo', this.blockNo);
  }

  onSelectedfloorNo(event: any) {
    this.floordetails = event.target.value;
    console.log('floordetails', this.floordetails);
  }

  onSelectedRoomtype(event: any) {
    this.Roomdetails = event.target.value;
    console.log('Roomdetails', this.Roomdetails);

  }

  // ngAfterViewInit() {
  //   this.inputElement.nativeElement.focus();
   
  // }


  onSubmit() {
    if (!this.searchorg) {
      alert('Please Enter Fusion Building Code.');
      this.inputElement.nativeElement.focus();
      return;
    }
    if (!this.catMajorId) {
      alert('Please Select Major Category');
      return;
    }
    if (!this.catMinorId) {
      alert('Please Select Minor Category');
      return;
    }
    if (!this.orgId) {
      alert('Please Select Organization');
      return;
    }
    if (!this.blockNodetails) {
      alert('Please Select Block No.');
      return;
    }
    if (!this.blockName) {
      alert('Please Enter Block Name.');
      this.blocknameElement.nativeElement.focus();
      return;
    }
    if (!this.floordetails) {
      alert('Please Select Floor');
      return;
    }
    if (!this.Roomdetails) {
      alert('Please Select Room Type');
      return;
    }

    if (!this.roomNo) {
      alert('Please Enter Room No.');
      this.roomElement.nativeElement.focus();
      return;
    }
    if (!this.noAssets) {
      alert('Please Enter No of Asset.');
      this.noAssetElement.nativeElement.focus();
      return;
    }
    
    var payload = {
      "buildingId": this.buildingId,
      "orgId": this.orgId,
      "totalAssets": this.noAssets,
      "assetPoNo": this.poNo,
      "catMinorId": this.catMinorId,
      "blockNo": this.blockNodetails,
      "blockName": this.blockName,
      "floorNo": this.floordetails,
      "roomNo": this.roomNo,
      "roomType": this.Roomdetails
    }
    console.log('payload', payload);
    this.spinner.show();
    if (confirm('Do you want to save Assets Details')) {
      this.assetsservice.assetssave(payload).subscribe(
        {
          next: (res: any) => {
            this.saveDetails = res;
            console.log('saveDetails', this.saveDetails);
            this.spinner.hide();
            this.toast.showSuccess(this.saveDetails.message);
            this.dialogRef.close('save');
          },
          error: (error: any) => {
            this.toast.showError(error.error.message);
            console.log('error', error.error.message);

            this.spinner.hide();
          }
        }
      );
    }
    else {
      this.spinner.hide();
    }
  }

}
